import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GraduationCap, ArrowRight } from "lucide-react";
import { api } from "../lib/api";

export default function JobCourses({ slug }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!slug) return;
    api.get(`/courses/for-job/${slug}`).then((r) => setData(r.data)).catch(() => setData({ items: [] }));
  }, [slug]);

  if (!data || !data.items?.length) return null;

  return (
    <div className="bg-white border border-zinc-200 rounded-lg p-5" data-testid="job-courses">
      <p className="text-xs font-bold uppercase tracking-wider text-blue-700 flex items-center gap-1.5">
        <GraduationCap size={14} /> Build the skills for this role
      </p>
      <div className="mt-3 space-y-2.5">
        {data.items.map((c) => (
          <a key={c.id} href={c.url || "/courses"} target={c.url ? "_blank" : undefined} rel="noopener noreferrer"
            data-testid={`job-course-${c.id}`}
            className="block border border-zinc-100 rounded-md p-3 hover:border-blue-300 hover:bg-blue-50/30 transition-colors duration-200">
            <p className="text-sm font-semibold text-zinc-900 leading-snug">{c.title}</p>
            <p className="text-xs text-zinc-500 mt-0.5">
              {c.provider}{c.online ? " · Online" : c.location ? ` · ${c.location}` : ""}
            </p>
          </a>
        ))}
      </div>
      <Link to={`/courses?category=${encodeURIComponent(data.category || "")}`} data-testid="job-courses-more"
        className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-blue-700 hover:underline">
        More {data.category || ""} courses <ArrowRight size={12} />
      </Link>
    </div>
  );
}
